<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR MOTIVO' : 'NOVO MOTIVO'" titleIcon="fas fa-tag">
            <div v-if="!carregado" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]">
                            <el-select v-model="dados.tipo" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t" :value="t" :label="rotuloTipo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Código (Censo)">
                            <el-input v-model="dados.codigo" maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Exige justificativa?">
                            <el-select v-model="dados.exige_justificativa" style="width: 100%;">
                                <el-option :value="false" label="Não"></el-option>
                                <el-option :value="true" label="Sim"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Exige documento?">
                            <el-select v-model="dados.exige_documento" style="width: 100%;">
                                <el-option :value="false" label="Não"></el-option>
                                <el-option :value="true" label="Sim"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="Ativo"></el-option>
                                <el-option :value="false" label="Inativo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Descrição">
                    <el-input v-model="dados.descricao" type="textarea" :rows="3"></el-input>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/motivo"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO E — item 33. */
export default {
    data: () => ({
        carregado: false, tipos: [],
        dados: { tipo: '', nome: '', codigo: '', descricao: '',
                 exige_justificativa: false, exige_documento: false, situacao: true }
    }),
    computed: {
        /**
         * Esconder o botão NÃO é segurança — o backend continua sendo a autoridade.
         * Isso só evita oferecer ao perfil Consulta uma ação que a API vai recusar.
         */
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
 modoEdicao () { return !!this.$route.params.id } },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/motivo/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.tipos = (r.data && r.data.tipos) ? r.data.tipos : [] }).catch(() => {})

        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/motivo/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/motivo')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        } else this.carregado = true
    },
    methods: {
        rotuloTipo (t) {
            return { movimentacao_matricula: 'Movimentação de matrícula', remanejamento: 'Remanejamento',
                dispensa_componente: 'Dispensa de componente', cancelamento: 'Cancelamento',
                reclassificacao: 'Reclassificação' }[t] || t
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/motivo/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/motivo/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Motivo salvo.', type: 'success' })
                    this.$router.push('/admin/motivo')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
